// extracted by mini-css-extract-plugin
module.exports = {"shippingDetailsTypos--WRAPPER":"SuccessfulOrderStep_shippingDetailsTypos--WRAPPER__Cxujr"};